// extracted by mini-css-extract-plugin
export default {"mainT":"Styling_mainT__5IA6i","cusPay":"Styling_cusPay__UBjM0","CustomerInfo":"Styling_CustomerInfo__SMTCD"};